module.exports = __webpack_public_path__ + "static/teluspark-logo-954aadd79c48c70ebd882fccfa8611ce.png";